module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty-title":"No interaction","empty-text":"<p>You do not have completed any interaction.</p>","interactions":"Interactions"},"fr":{"empty-title":"Aucune interaction","empty-text":"<p>Vous n\u0027avez complété aucune interaction.</p>","interactions":"Interactions"}}')
  delete Component.options._Ctor
}
